import store from '@/store';

const getScrollState = () => {
  const scrollTop = store.getters['layout/getScrollTop'];
  return Array.isArray(scrollTop) ? scrollTop : [];
};

export const getRemindedScroll = (path) => {
  return getScrollState().find((elem) => elem.path === path) ?? null;
};

export const recoverScroll = (path, options = {}) => {
  const { behavior = 'smooth' } = options;
  const scrollTarget = document.getElementById(`scrollable${path}`);
  if (!scrollTarget) return null;

  const scrollTop = getScrollState();
  if (!scrollTop.length) return null;

  const targetIndex = scrollTop.findIndex((elem) => elem.path === path);
  if (targetIndex < 0) return null;

  const [target] = scrollTop.splice(targetIndex, 1);
  if (!target) return null;

  scrollTarget.scrollTo({ left: 0, top: target.top, behavior });

  store.commit('layout/setScrollTop', scrollTop);
  return target;
};

export const remindScroll = (path, payload = {}) => {
  const scrollTop = document.getElementById(`scrollable${path}`);
  if (!scrollTop) return null;

  const top = scrollTop.scrollTop;
  const nextScrollTop = getScrollState().filter((elem) => elem.path !== path);
  const target = { path, top, ...payload };

  store.commit('layout/setScrollTop', [...nextScrollTop, target]);
  return target;
};
